/**
 * Storage permissions.
 *
 * @id - Used to identify the rule on permissions and upload.
 * @folder - Folder where the files will be saved
 * @maxSizeInBytes - Max allowed size in bytes
 * @bypassWritingPermissions - Does not validate if the user has permission to write
 * @publicRead - The file can be publicly accessed via the URL without the need for a signed token
 */
export default class Storage {
  static get values() {
    return {
      indicatorAttachments: {
        id: 'indicatorAttachments',
        folder: 'tenant/:tenantId/indicator/attachments',
        maxSizeInBytes: 100 * 1024 * 1024,
      },

      locationAvatar: {
        id: 'locationAvatar',
        folder: 'tenant/:tenantId/location/avatar',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      resourceInstructionsPhoto: {
        id: 'resourceInstructionsPhoto',
        folder:
          'tenant/:tenantId/resource/instructions/photo',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      formTemplateStartPagePhoto: {
        id: 'formTemplateStartPagePhoto',
        folder:
          'tenant/:tenantId/formTemplate/startPage/photo',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      notificationIcon: {
        id: 'notificationIcon',
        folder: 'tenant/:tenantId/notification/icon',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      resourceClosureEvidencePhoto: {
        id: 'resourceClosureEvidencePhoto',
        folder:
          'tenant/:tenantId/resource/closureEvidence/photo',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      resourceConditionPhotos: {
        id: 'resourceConditionPhotos',
        folder:
          'tenant/:tenantId/resource/condition/photos',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      resourceStartPagePhoto: {
        id: 'resourceStartPagePhoto',
        folder: 'tenant/:tenantId/resource/startPage/photo',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      formTemplateInstructionsPhoto: {
        id: 'formTemplateInstructionsPhoto',
        folder:
          'tenant/:tenantId/formTemplate/instructions/photo',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      resourceIcon: {
        id: 'resourceIcon',
        folder: 'tenant/:tenantId/resource/icon',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      formCategoryIcon: {
        id: 'formCategoryIcon',
        folder: 'tenant/:tenantId/formCategory/icon',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      assetIcon: {
        id: 'assetIcon',
        folder: 'tenant/:tenantId/asset/icon',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      formTemplateIcon: {
        id: 'formTemplateIcon',
        folder: 'tenant/:tenantId/formTemplate/icon',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      formTemplatePreviewImage: {
        id: 'formTemplatePreviewImage',
        folder:
          'tenant/:tenantId/formTemplate/previewImage',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      formTemplateBuilder: {
        id: 'formTemplateBuilder',
        folder: 'tenant/:tenantId/formTemplate/builder',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      workflowIcon: {
        id: 'workflowIcon',
        folder: 'tenant/:tenantId/workflow/icon',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },

      settingsLogos: {
        id: 'settingsLogos',
        folder: 'tenant/:tenantId/settings/logos',
        maxSizeInBytes: 10 * 1024 * 1024,
        publicRead: true,
      },
      settingsBackgroundImages: {
        id: 'settingsBackgroundImages',
        folder:
          'tenant/:tenantId/settings/backgroundImages',
        maxSizeInBytes: 10 * 1024 * 1024,
        publicRead: true,
      },
      userAvatarsProfiles: {
        id: 'userAvatarsProfiles',
        folder: 'user/avatars/profile/:userId',
        maxSizeInBytes: 10 * 1024 * 1024,
        bypassWritingPermissions: true,
        publicRead: true,
      },

      appUserPhoto: {
        id: 'appUserPhoto',
        folder: 'tenant/:tenantId/appUser/photo',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },
      appUserSignature: {
        id: 'appUserSignature',
        folder: 'tenant/:tenantId/appUser/signature',
        maxSizeInBytes: 100 * 1024 * 1024,
        publicRead: true,
      },
    };
  }
}
